export default __webpack_public_path__ + "bccba2e689a929e2df172b1b94019727.png";